import ForceGraph3D from '3d-force-graph';
import * as THREE from 'three';
import * as d3 from 'd3';
import graphData from './force_all.json';

// Extended mapping for colors and opacity
const styleMap = {
    'A': { color: '#D2042D', opacity: 0.8},
    'B': { color: '#1F51FF', opacity: 0.8},
    'C': { color: '#FFA500', opacity: 0.8},
    'D': { color: '#8B5A2B', opacity: 0.8},
    'E': { color: '#9400D3', opacity: 0.8},
    'F': { color: '#FFFF00', opacity: 0.8},
    'G': { color: '#008B8B', opacity: 0.8},
    'H': { color: '#FFFACD', opacity: 0.8},
};

const myGraph = ForceGraph3D()(document.getElementById('3d-graph'))
    .graphData(graphData)
    .nodeThreeObject(node => {
        // Default styling if node class is not found
        const defaultStyle = { color: 'white', opacity: 0.5 };

        // Retrieve style from map or use default
        const nodeStyle = styleMap[node.class] || defaultStyle;

        const material = new THREE.MeshLambertMaterial({
            color: nodeStyle.color, // Set color from style map
            transparent: true,
            opacity: nodeStyle.opacity // Set opacity from style map
        });

        const geometry = new THREE.SphereGeometry(node.size * 2, 8, 8);
        return new THREE.Mesh(geometry, material);
    })
    .linkVisibility(true)
    .linkWidth(link => link.strength * 3)
    .linkOpacity(0.4)
    .nodeLabel('name')
    .cooldownTicks(100)
    .cooldownTime(15000);
